import styled from 'styled-components';

type Props = {
  tabIndex: number;
  ref: (div: HTMLDivElement) => void;
};
export const ScrollToElementStyled = styled.div<Props>`
  :focus {
    outline: none !important;
  }
`;
